<template>
  <div>
    <b-button-group>
      <b-button
        class="bg-transparent border-0 hover-blue menu-link"
        @click="routeTo('/staffLeaveRecord')"
        v-if="isLeaveRecordVisible"
        >{{ `${this.t.t(dictEnum.MENU_StaffLeaveRecord)} ` }}
        <span
          :class="{
            bdr: true,
            'bg-image-rainbow': this.$route.path === '/staffLeaveRecord'
          }"
        ></span>
      </b-button>
      <b-button
        class="bg-transparent border-0 hover-blue menu-link"
        @click="routeTo('/staffAttendance')"
        v-if="isLeaveRecordVisible"
        >{{ `${this.t.t(dictEnum.MENU_StaffAttendance)} ` }}
        <span
          id="tempSSS"
          :class="{
            bdr: true,
            'bg-image-rainbow': this.$route.path === '/staffAttendance'
          }"
        ></span>
      </b-button>
      <b-button
        class="bg-transparent border-0 hover-blue menu-link"
        @click="routeTo('/monthlyLeaveBalance')"
        v-if="isMonthlyVisible"
        >{{ `${this.t.t(dictEnum.MENU_MonthlyLeaveBalance)} ` }}
        <span
          :class="{
            bdr: true,
            'bg-image-rainbow': this.$route.path === '/monthlyLeaveBalance'
          }"
        ></span>
      </b-button>
      <b-button
        class="bg-transparent border-0 hover-blue menu-link"
        @click="routeTo('/outdoorWorkAllowance')"
        v-if="isOutdoorVisible"
        >{{ `${this.t.t(dictEnum.MENU_OutdoorWorkAllowance)} ` }}
        <span
          :class="{
            bdr: true,

            'bg-image-rainbow': this.$route.path === '/outdoorWorkAllowance'
          }"
        ></span>
      </b-button>
      <b-button
        class="bg-transparent border-0 hover-blue menu-link"
        @click="routeTo('/taxReturn')"
        v-if="isTaxReturnVisible"
        >{{ `${this.t.t(dictEnum.MENU_TaxReturn)} ` }}
        <span
          :class="{
            bdr: true,

            'bg-image-rainbow': this.$route.path === '/taxReturn'
          }"
        ></span>
      </b-button>
    </b-button-group>
  </div>
</template>
<script>
export default {
  props: [
    "t",
    "dictEnum",
    "isLeaveRecordVisible",
    "isStaffAttendanceVisible",
    "isMonthlyVisible",
    "isOutdoorVisible",
    "isTaxReturnVisible"
  ],
  methods: {
    routeTo(path) {
      this.$router.push({ path: path });
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-link {
  color: #337ab7;
}
</style>



// WEBPACK FOOTER //
// src/components/S040000-Report/S040000-Menu.vue